// Constantes del módulo Denials Management & Appeals (Módulo G — BillingV2).

/** Estados del denial en el workflow de apelación. */
export const DENIAL_STATUS = {
  NEW: "new",
  IN_APPEAL: "in_appeal",
  RECOVERED: "recovered",
  WRITTEN_OFF: "written_off",
};

export const DENIAL_STATUS_META = {
  [DENIAL_STATUS.NEW]: { tone: "info", label: "New" },
  [DENIAL_STATUS.IN_APPEAL]: { tone: "warn", label: "In appeal" },
  [DENIAL_STATUS.RECOVERED]: { tone: "ok", label: "Recovered" },
  [DENIAL_STATUS.WRITTEN_OFF]: { tone: "muted", label: "Written off" },
};

/** Clasificación de causa raíz (catálogo billing.TAB_DENIAL_REASONS). */
export const ROOT_CAUSES = {
  AUTH: "Authorization missing or invalid",
  CODING: "Coding / diagnosis mismatch",
  ELIGIBILITY: "Eligibility / coverage issue",
  TIMELY_FILING: "Timely filing",
  DOCUMENTATION: "Insufficient documentation",
  DUPLICATE: "Duplicate claim",
  BUNDLING: "Bundling / NCCI edit",
};

/** Pasos del closed-loop de apelación. */
export const APPEAL_STEPS = ["Denied", "Root cause", "Appeal filed", "Outcome"];
